module.exports = __webpack_public_path__ + "static/media/konserdongengbanner.5ffc8c98.jpeg";